import React, {Component} from 'react'
import { Layout, Menu, Row, Col } from 'antd';
import {Link, Route, Switch} from "react-router-dom";
import './App.css';
import Home from "./Home";
const { Header, Footer, Content } = Layout;

class App extends Component {

    render() {

        const routes = [
            {
                path: "/",
                exact: true,
                menu: 'Home',
                key: 'home',
                content: () => <Home/>
            },
        ];

        return (
            <Layout>
                <Header id='header' className='clearfix'>
                    <div className='header-inner'>
                        <Menu
                            id='nav'
                            theme="light"
                            mode="horizontal"
                            style={{ lineHeight: '45px' }}
                        >
                            {
                                routes.map((route, index) => (
                                    <Menu.Item key={route.key}>
                                        <Link to={route.path}>{route.menu}</Link>
                                    </Menu.Item>
                                ))
                            }
                        </Menu>
                    </div>
                </Header>
                <Content>
                    <div id='content'>
                        <div className='container'>
                            <Switch>
                                <Route exact path='/' component={Home}/>
                            </Switch>
                        </div>
                    </div>
                </Content>
                <Footer id='footer'>© Tareq Aziz 2018.</Footer>
            </Layout>
        )
    }

}

export default App